import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';

export default function ForgotPasswordPage() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const { error: err } = await resetPassword(email);
    setLoading(false);
    if (err) {
      setError(err);
    } else {
      setSent(true);
    }
  }

  if (sent) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-pix-void px-4">
        <div className="w-full max-w-sm text-center">
          <h1 className="mb-2 text-2xl font-bold text-white">Check your email</h1>
          <p className="text-sm text-white/50">
            We sent a password reset link to <strong>{email}</strong>.
          </p>
          <Link to="/login" className="mt-6 block text-sm font-medium text-pix-pink hover:text-pix-pink">
            Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-pix-void px-4">
      <div className="w-full max-w-sm">
        <h1 className="mb-1 text-2xl font-bold text-white">Reset your password</h1>
        <p className="mb-6 text-sm text-white/50">
          Enter your email and we will send you a reset link.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-white/70">
              Email
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 block w-full rounded-md border border-white/15 bg-pix-void px-3 py-2 text-sm text-white shadow-sm focus:border-pix-pink/50 focus:outline-none focus:ring-1 focus:ring-pix-pink/50"
            />
          </div>

          {error && <p className="text-sm text-red-400">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-md bg-pix-pink px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pix-pink-dark disabled:opacity-50"
          >
            {loading ? 'Sending...' : 'Send reset link'}
          </button>
        </form>

        <p className="mt-6 text-center text-sm text-white/50">
          <Link to="/login" className="font-medium text-pix-pink hover:text-pix-pink">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
